export default {
  setCommodities(state, data) {
    state.commodities = data;
  },

  setCompanies(state, data) {
    state.companies = data;
  },

  setBranches(state, data) {
    state.branches = data;
  },

  setMyBranches(state, data) {
    state.myBranches = data;
  },

  setMyFiscalYear(state, data) {
    state.myFiscalYear = data;
  },

  setRoles(state, data) {
    state.roles = data;
  },

  setUnits(state, data) {
    state.units = data;
  },

  setMaterials(state, data) {
    state.materials = data;
  },

  setProducts(state, data) {
    state.products = data;
  },

  setCustomers(state, data) {
    state.customers = data;
  },

  setCategories(state, data) {
    state.categories = data;
  },

  setBranchYears(state, data) {
    state.branchYears = data;
  },

  setUsers(state, data) {
    state.users = data;
  },

  setOrdrSettlementTypes(state, data) {
    state.ordrSettlementTypes = data || [];
  },
  setWares(state, data) {
    state.wares = data;
  },

  setWareShelfInfos(state, data) {
    state.wareShelfInfos = data;
  },
  setWareShelfInfos2(state, data) {
    state.wareShelfInfos2 = data;
  },

  setWaresWithoutLimit(state, data) {
    state.waresWithoutLimit = data;
  },

  setWareCategories(state, data) {
    state.wareCategories = data;
  },

  setCountries(state, data) {
    state.countries = data;
  },

  setAllProvinces(state, data) {
    state.allProvinces = data;
  },

  setProvinces(state, data) {
    state.provinces = data;
  },

  setProvincesForAddress(state, data) {
    state.provincesForAddress = data;
  },

  setAllCities(state, data) {
    state.allCities = data;
  },

  setCities(state, data) {
    state.cities = data;
  },

  setCitiesForAddress(state, data) {
    state.citiesForAddress = data;
  },

  setRegions(state, data) {
    state.regions = data;
  },

  setPersonTypes(state, data) {
    state.personTypes = data;
  },

  setPersons(state, data) {
    state.persons = data;
  },

  setPrefixes(state, data) {
    state.prefixes = data;
  },

  setPersonGroups(state, data) {
    state.personGroups = data;
  },

  setPersonBranches(state, data) {
    state.personBranches = data;
  },

  setPositionInformation(state, data) {
    state.positionInformation = data;
  },

  setMaritalStatuses(state, data) {
    state.maritalStatuses = data;
  },

  setSbus(state, data) {
    state.sbus = data;
  },
  setSbuTypes(state, data) {
    state.sbuTypes = data;
  },

  setBoms(state, data) {
    state.boms = data;
  },

  setOrders(state, data) {
    state.orders = data;
  },

  setProduceOrderProcesses(state, data) {
    state.produceOrderProcesses = data;
  },

  setUserGroups(state, data) {
    state.userGroups = data;
  },

  setBranchFiscalYears(state, data) {
    state.branchFiscalYears = data;
  },

  setFiscalYearById(state, data) {
    state.fiscalYearById = data;
  },

  setPermissions(state, data) {
    state.permissions = Object.freeze(data || []);
  },

  setCompanySubSystems(state, data) {
    state.companySubSystems = data || [];
    state.companySubSystemsLoaded = true;
  },

  resetCompanySubSystems(state) {
    state.companySubSystems = [];
    state.companySubSystemsLoaded = false;
  },

  setFloatAccounts(state, data) {
    state.floatAccounts = data;
  },
  setFloatAccountTypes(state, data) {
    state.floatAccountTypes = data;
  },

  setFloatAccountGroups(state, data) {
    state.floatAccountGroups = data;
  },

  setFloatAccountGroups1(state, data) {
    state.floatAccountGroups1 = data;
  },

  setFloatAccountGroups2(state, data) {
    state.floatAccountGroups2 = data;
  },

  setFloatAccountGroups3(state, data) {
    state.floatAccountGroups3 = data;
  },

  setFloatAccountGroups4(state, data) {
    state.floatAccountGroups4 = data;
  },

  setFloatAccountGroups5(state, data) {
    state.floatAccountGroups5 = data;
  },

  setGender(state, data) {
    state.gender = data;
  },

  setCommodityGroups(state, data) {
    state.commodityGroups = data;
  },

  setInvoiceTypes(state, data) {
    state.invoiceTypes = data;
  },

  setPersonGrades(state, data) {
    state.personGrades = data;
  },

  setWareVoucherTypes(state, data) {
    state.wareVoucherTypes = data;
  },

  setAdditionalCommodityParamenterTypes(state, data) {
    state.additionalCommodityParamenterTypes = data;
  },

  setFiledTypes(state, data) {
    state.filedTypes = data;
  },

  setReceiptWareVoucherTypes(state, data) {
    state.receiptWareVoucherTypes = data;
  },

  setTempReceiptWareVoucherTypes(state, data) {
    state.tempReceiptWareVoucherTypes = data;
  },

  setFloatAccountConfigs(state, data) {
    state.floatAccountConfigs = data;
  },

  setFloatAccounts1(state, data) {
    state.floatAccounts1 = data;
  },

  setFloatAccounts2(state, data) {
    state.floatAccounts2 = data;
  },

  setFloatAccounts3(state, data) {
    state.floatAccounts3 = data;
  },

  setFloatAccounts4(state, data) {
    state.floatAccounts4 = data;
  },

  setFloatAccounts5(state, data) {
    state.floatAccounts5 = data;
  },

  setFloatAccountText(state, data) {
    state.floatAccountText = data;
  },

  setReviewVoucherAmountFilterTypes(state, data) {
    state.reviewVoucherAmountFilterTypes = data;
  },

  setAdditionalCommodityParameters(state, data) {
    state.additionalCommodityParameters = data;
  },

  setAccountTypes(state, data) {
    state.accountTypes = data;
  },

  setAccountControls(state, data) {
    state.accountControls = data;
  },

  setAccountActions(state, data) {
    state.accountActions = data;
  },
  setAccountInfos(state, data) {
    state.accountInfos = data;
  },

  setDataOperations(state, data) {
    state.dataOperations = data;
  },

  setDataUsers(state, data) {
    state.dataUsers = data;
  },

  setDraftWareVoucherType(state, data) {
    state.draftWareVoucherType = data;
  },

  setSuppliers(state, data) {
    state.suppliers = data;
  },

  setCashiers(state, data) {
    state.cashiers = data;
  },

  setBuyers(state, data) {
    state.buyers = data;
  },

  setReceivers(state, data) {
    state.receivers = data;
  },

  setSbuTree(state, data) {
    state.sbuTree = data;
  },

  setWareCommodities(state, data) {
    state.wareCommodities = data;
  },

  setDestinationWareCommodities(state, data) {
    state.destinationWareCommodities = data;
  },

  setPositionInfoTree(state, data) {
    state.positionInfoTree = data;
  },

  setCartable(state, data) {
    state.cartable = data;
  },

  setDrafts(state, data) {
    state.drafts = data;
  },

  setCommodityUnitCounts(state, data) {
    state.commodityUnitCounts = data;
  },

  setCommodityParameters(state, data) {
    state.commodityParameters = data[0];
  },

  setCommodityBatches(state, data) {
    state.commodityBatches = data;
  },

  setItemGroupTree(state, data) {
    state.itemGroupTree = data;
  },

  setBuyRequests(state, data) {
    state.buyRequests = data;
  },

  setVehicleTypes(state, data) {
    state.vehicleTypes = data;
  },

  setWarehousingTypes(state, data) {
    state.warehousingTypes = data;
  },

  setTempReceipts(state, data) {
    state.tempReceipts = data;
  },

  setPersonClubGroups(state, data) {
    state.personClubGroups = data;
  },

  setPersonClubs(state, data) {
    state.personClubs = data;
  },

  setDeliveryMethods(state, data) {
    state.deliveryMethods = data;
  },

  setPaymentMethods(state, data) {
    state.paymentMethods = data;
  },

  setOccasionTypes(state, data) {
    state.occasionTypes = data;
  },

  setCampaignTypes(state, data) {
    state.campaignTypes = data;
  },

  setSalesChannels(state, data) {
    state.salesChannels = data;
  },

  setIntroducedTypes(state, data) {
    state.introducedTypes = data;
  },

  setTags(state, data) {
    state.tags = data;
  },

  setProcessTypes(state, data) {
    state.processTypes = data;
  },

  setFeedBackTypes(state, data) {
    state.feedBackTypes = data;
  },

  setProcessServiceTypes(state, data) {
    state.processServiceTypes = data;
  },

  setFeedBacks(state, data) {
    state.feedBacks = data;
  },

  setWorkStations(state, data) {
    state.workStations = data;
  },

  setGrades(state, data) {
    state.grades = data;
  },

  setFeedbackQuestionOptions(state, data) {
    state.feedbackQuestionOptions = data;
  },

  setFinancialRatios(state, data) {
    state.financialRatios = data;
  },

  setAnswerTypes(state, data) {
    state.answerTypes = data;
  },
  setCurrencyTypes(state, data) {
    state.currencyTypes = data;
  },

  setSmsTemplates(state, data) {
    state.smsTemplates = data;
  },

  setSaleSettings(state, data) {
    state.saleSettings = data;
  },

  setTurnTypes(state, data) {
    state.turnTypes = data;
  },

  setChequeStatusTypes(state, data) {
    state.chequeStatusTypes = data;
  },

  setBanks(state, data) {
    state.banks = data;
  },

  setBankBranchs(state, data) {
    state.bankBranchs = data;
  },

  setChequeTemplates(state, data) {
    state.chequeTemplates = data;
  },

  setBankCashAccount(state, data) {
    state.bankCashAccount = data;
  },

  setRequestType(state, data) {
    state.requestType = data;
  },
  setVoucherNoteTypes(state, data) {
    state.voucherNoteTypes = data;
  },

  setDefaultVoucherDescriptions(state, data) {
    state.defaultVoucherDescriptions = data;
  },

  setChequeStatuses(state, data) {
    state.chequeStatuses = data;
  },

  setVoucherTemplateType(state, data) {
    state.voucherTemplateType = data;
  },

  setVoucherTemplateKeyType(state, data) {
    state.voucherTemplateKeyType = data;
  },

  setSmsTypes(state, data) {
    state.smsTypes = data;
  },
  setTransactionInfo(state, data) {
    state.transactionInfo = data;
  },

  setPrakCommodityGroup(state, data) {
    state.parakCommodityGroup = data;
  },

  setParakCommodities(state, data) {
    state.parakCommodities = data;
  },

  setRequestPayment(state, data) {
    state.requestPayment = data;
  },

  setChequeBatches(state, data) {
    state.chequeBatches = data;
  },

  setDateTypes(state, data) {
    state.dateTypes = data;
  },

  setSettingDropdownCache(state, { path, data }) {
    if (!state.settingDropdownCache) {
      state.settingDropdownCache = {};
    }
    data.forEach((item) => {
      item.id = String(item.id);
    });
    this._vm.$set(state.settingDropdownCache, path, data);
  },

  setPackageTypes(state, data) {
    state.packageTypes = data;
  },

  setMRPProcessTypes(state, data) {
    state.MRPProcessTypes = data;
  },
  setSubMRPProcessTypes(state, data) {
    state.subMRPProcessTypes = data;
  },

  setExcelSampleType(state, data) {
    state.excelSampleType = data;
  },

  setExcelSampleDetailType(state, data) {
    state.excelSampleDetailType = data;
  },

  setExcelSampleDetailInformationType(state, data) {
    state.excelSampleDetailInformationType = data;
  },

  setExcelSampleDetailTurnIntoType(state, data) {
    state.excelSampleDetailTurnIntoType = data;
  },

  setReceiveChequeFilters(state, data) {
    state.receiveChequeFilters = data;
  },

  setPaymentChequeFilters(state, data) {
    state.paymentChequeFilters = data;
  },

  setReceipts(state, data) {
    state.receipts = data;
  },

  setSprints(state, data) {
    state.sprints = data;
  },

  setProduceOrders(state, data) {
    state.produceOrders = data;
  },

  setCoilCertificates(state, data) {
    state.coilCertificates = data;
  },

  setMonthlyComparisonReceiveChequeFilters(state, data) {
    state.monthlyComparisonReceiveChequeFilters = data;
  },

  setMonthlyComparisonPaymentChequeFilters(state, data) {
    state.monthlyComparisonPaymentChequeFilters = data;
  },

  setSummaryPaymentChequeFilters(state, data) {
    state.summaryPaymentChequeFilters = data;
  },

  setSummaryReceiveChequeFilters(state, data) {
    state.summaryReceiveChequeFilters = data;
  },

  setCasterProduceOrders(state, data) {
    state.casterProduceOrders = data;
  },

  setProductionReports(state, data) {
    state.productionReports = data;
  },

  setWorkStationStatuses(state, data) {
    state.workStationStatuses = data;
  },

  setInputTypes(state, data) {
    state.inputTypes = data;
  },

  setProductionGroups(state, data) {
    state.productionGroups = data;
  },

  setPurchaseContracts(state, data) {
    state.purchaseContracts = data;
  },

  setSaleTypes(state, data) {
    state.saleTypes = data;
  },

  setOrderCommodities(state, data) {
    state.orderCommodities = data;
  },

  setOrderCommodityStatus(state, data) {
    state.orderCommodityStatus = data;
  },

  setOrderBoms(state, data) {
    state.orderBoms = data;
  },

  setProductionGroupSuppliers(state, data) {
    state.productionGroupSuppliers = data;
  },

  setAgents(state, data) {
    state.agents = data;
  },

  setSalesManagers(state, data) {
    state.salesManagers = data;
  },

  setPurchaseManagers(state, data) {
    state.purchaseManagers = data;
  },

  setDistributors(state, data) {
    state.distributors = data;
  },

  setDrivers(state, data) {
    state.drivers = data;
  },

  setSellers(state, data) {
    state.sellers = data;
  },

  setEmployers(state, data) {
    state.employers = data;
  },

  setEmployees(state, data) {
    state.employees = data;
  },

  setContractors(state, data) {
    state.contractors = data;
  },

  setBomSetting(state, data) {
    state.bomSetting = data;
  },

  setParakPersonDealTypes(state, data) {
    state.parakPersonDealTypes = data;
  },

  setParakCottage(state, data) {
    state.parakCottage = data;
  },

  setParakSettlementType(state, data) {
    state.parakSettlementType = data;
  },

  setParakOrderOperations(state, data) {
    state.parakOrderOperations = data;
  },

  setParakPurchases(state, data) {
    state.parakPurchases = data;
  },

  setParakOrders(state, data) {
    state.parakOrders = data;
  },

  setParakVoucherType(state, data) {
    state.parakVoucherType = data;
  },

  setParakLadingOperation(state, data) {
    state.parakLadingOperation = data;
  },

  setPersonAddress(state, data) {
    state.personAddress = data;
  },

  setCommodityAdditionalInfos(state, data) {
    state.commodityAdditionalInfos = data;
  },

  setAddMinusType(state, data) {
    state.addMinusType = data;
  },

  setSaleExcelSampleType(state, data) {
    state.saleExcelSampleType = data;
  },

  setSaleExcelSampleDetailType(state, data) {
    state.saleExcelSampleDetailType = data;
  },

  setCancelStatuses(state, data) {
    state.cancelStatuses = data;
  },

  setBuyFactorTypes(state, data) {
    state.buyFactorTypes = data;
  },

  setReturnedFactorTypes(state, data) {
    state.returnedFactorTypes = data;
  },

  setSaleSaleTypes(state, data) {
    state.saleSaleTypes = data;
  },

  setSalePricePolicesTypes(state, data) {
    state.salePricePolicesTypes = data;
  },

  setSaleFactorTypes(state, data) {
    state.saleFactorType = data;
  },

  setSaleCancelStatus(state, data) {
    state.saleCancelStatus = data;
  },

  setSaleVoucherStatus(state, data) {
    state.saleVoucherStatus = data;
  },

  setSalePricePolices(state, data) {
    state.salePricePolices = data;
  },

  setSaleAddMinuses(state, data) {
    state.saleAddMinuses = data;
  },

  setReceiveAndPay(state, data) {
    state.receiveAndPay = data;
  },

  setAccountConfigs(state, data) {
    state.accountConfigs = data;
  },

  setSearchTypes(state, data) {
    state.searchTypes = data;
  },

  setDocumentTypes(state, data) {
    state.documentTypes = data;
  },

  setSaleAgents(state, data) {
    state.saleAgents = data;
  },

  setFactorFormats(state, data) {
    state.factorFormats = data;
  },

  setSaleSaleManager(state, data) {
    state.saleSaleManager = data;
  },

  setSaleCommissionTypes(state, data) {
    state.saleCommissionTypes = data;
  },

  setScmsBuyTypes(state, data) {
    state.scmsBuyTypes = data;
  },

  setBuyAddMinuses(state, data) {
    state.buyAddMinuses = data;
  },

  setListSetting(state, data) {
    state.listSetting = data;
  },

  setSaleFactors(state, data) {
    state.saleFactors = data;
  },

  setVouchers(state, data) {
    state.vouchers = data;
  },

  setReportVouchers(state, data) {
    state.reportVouchers = data;
  },

  setReturnBuyFactors(state, data) {
    state.returnBuyFactors = data;
  },

  setTransferCommodites(state, data) {
    state.transferCommodites = data;
  },

  setWarehousings(state, data) {
    state.warehousings = data;
  },

  setProductions(state, data) {
    state.productions = data;
  },

  setReceiptCartableConfirm(state, data) {
    state.receiptCartableConfirm = data;
  },

  setDraftCartableConfirm(state, data) {
    state.draftCartableConfirm = data;
  },

  setSaleCartableConfirm(state, data) {
    state.saleCartableConfirm = data;
  },

  setSalesReturnCartableConfirm(state, data) {
    state.salesReturnCartableConfirm = data;
  },

  setBuyFactorCartableConfirm(state, data) {
    state.buyFactorCartableConfirm = data;
  },

  setBuyReturnCartableConfirm(state, data) {
    state.buyReturnCartableConfirm = data;
  },

  setReqBuyCartableConfirm(state, data) {
    state.reqBuyCartableConfirm = data;
  },

  setReqPaymentCartableConfirm(state, data) {
    state.reqPaymentCartableConfirm = data;
  },

  setChequePaymentCartableConfirm(state, data) {
    state.chequePaymentCartableConfirm = data;
  },

  setReceiveChequeCartableConfirm(state, data) {
    state.receiveChequeCartableConfirm = data;
  },

  setCurrentPersonInVoucherDetails(state, data) {
    state.currentPersonInVoucherDetails = data;
  },

  setBuyFactors(state, data) {
    state.buyFactors = data;
  },

  setReturnSaleFactors(state, data) {
    state.returnSaleFactors = data;
  },

  setTransactionTypes(state, data) {
    state.transactionTypes = data;
  },

  setPersonOfficeReportTypes(state, data) {
    state.personOfficeReportTypes = data;
  },

  setInspectionLevels(state, data) {
    state.inspectionLevels = data;
  },

  setDateTimeFormats(state, data) {
    state.dateTimeFormats = data;
  },

  setMonthlyAccountingVoucherKeyTypes(state, data) {
    state.monthlyAccountingVoucherKeyTypes = data;
  },

  setManagementCartable(state, data) {
    state.managementCartable = data;
  },

  setHardnesses(state, data) {
    state.hardnesses = data;
  },

  setProductSurfaces(state, data) {
    state.productSurfaces = data;
  },

  setUsageGroups(state, data) {
    state.usageGroups = data;
  },

  setFoilUsages(state, data) {
    state.foilUsages = data;
  },

  setInnerCoreDiameters(state, data) {
    state.innerCoreDiameters = data;
  },

  setReport(state, data) {
    state.report = data;
  },

  setReportDropDown(state, data) {
    state.reportDropDown = data;
  },

  setExportFileFormatTypes(state, data) {
    state.exportFileFormatTypes = data;
  },

  setTurnTypeReceived(state, data) {
    state.turnTypeReceived = data;
  },

  setTurnTypePayable(state, data) {
    state.turnTypePayable = data;
  },

  setTurnCashTypes(state, data) {
    state.turnCashTypes = data;
  },

  setReceiptPaymentSubjectTypes(state, data) {
    state.receiptPaymentSubjectTypes = data;
  },

  setReceiptPaymentSubjects(state, data) {
    state.receiptPaymentSubjects = data;
  },

  setChequeSayadAndBankInfo(state, data) {
    state.chequeSayadAndBankInfo = data;
  },

  setSaleDiscountTypes(state, data) {
    state.saleDiscountTypes = data;
  },

  setSaleProcesses(state, data) {
    state.saleProcesses = data;
  },

  setIssueTrackingTypes(state, data) {
    state.issueTrackingTypes = data;
  },

  setTrackingNumbersByChequeNumber(state, data) {
    state.trackingNumbersByChequeNumber = data;
  },

  setGoals(state, data) {
    state.goals = data;
  },

  setCampaigns(state, data) {
    state.campaigns = data;
  },

  setLeadSources(state, data) {
    state.leadSources = data;
  },

  setLeadStatuses(state, data) {
    state.leadStatuses = data;
  },

  setLeadPropertys(state, data) {
    state.leadPropertys = data;
  },

  setLeadTypes(state, data) {
    state.leadTypes = data;
  },

  setWorkShifts(state, data) {
    state.workShifts = data;
  },

  setLeadNotChances(state, data) {
    state.leadNotChances = data;
  },

  setChanceSaleStatuses(state, data) {
    state.chanceSaleStatuses = data;
  },

  setCampaignStatuses(state, data) {
    state.campaignStatuses = data;
  },

  setCampaignExecutionPhases(state, data) {
    state.campaignExecutionPhases = data;
  },

  setAgeGroups(state, data) {
    state.ageGroups = data;
  },

  setChanceTypes(state, data) {
    state.chanceTypes = data;
  },

  setChanceStatuses(state, data) {
    state.chanceStatuses = data;
  },

  setChanceResults(state, data) {
    state.chanceResults = data;
  },

  setSaleLines(state, data) {
    state.saleLines = data;
  },

  setSaleLineStages(state, data) {
    state.saleLineStages = data;
  },

  setSaleStageTypes(state, data) {
    state.saleStageTypes = data;
  },

  setChancePrioritys(state, data) {
    state.chancePrioritys = data;
  },

  setFailedSaleReasons(state, data) {
    state.failedSaleReasons = data;
  },

  setStrengthWeaknesses(state, data) {
    state.strengthWeaknesses = data;
  },

  setStrengthWeaknessTypes(state, data) {
    state.strengthWeaknessTypes = data;
  },

  setFurnaces(state, data) {
    state.furnaces = data;
  },

  setFurnacePlacements(state, data) {
    state.furnacePlacements = data;
  },

  setOrderDateTypes(state, data) {
    state.orderDateTypes = data;
  },

  setProjectTypes(state, data) {
    state.projectTypes = data;
  },

  setProjectExecutionPhases(state, data) {
    state.projectExecutionPhases = data;
  },

  setLeads(state, data) {
    state.leads = data;
  },

  setProjects(state, data) {
    state.projects = data;
  },

  setWorkDescriptions(state, data) {
    state.workDescriptions = data;
  },

  setTaskStatuses(state, data) {
    state.taskStatuses = data;
  },

  setTaskCategorys(state, data) {
    state.taskCategorys = data;
  },

  setNoteCategorys(state, data) {
    state.noteCategorys = data;
  },

  setNoteSubjects(state, data) {
    state.noteSubjects = data;
  },

  setNoteStatuses(state, data) {
    state.noteStatuses = data;
  },

  setHamyarRequestTypes(state, data) {
    state.hamyarRequestTypes = data;
  },

  setRequestStatuses(state, data) {
    state.requestStatuses = data;
  },

  setServiceSupports(state, data) {
    state.serviceSupports = data;
  },
  setServiceSupportSubjects(state, data) {
    state.serviceSupportSubjects = data;
  },
  setServiceSupportStatuses(state, data) {
    state.serviceSupportStatuses = data;
  },
  setServiceSupportCategories(state, data) {
    state.serviceSupportCategories = data;
  },
  setServiceSupportAnnouncementTypes(state, data) {
    state.serviceSupportAnnouncementTypes = data;
  },
  setServiceSupportActionTypes(state, data) {
    state.serviceSupportActionTypes = data;
  },
  setHamyarContractTypes(state, data) {
    state.hamyarContractTypes = data;
  },
  setHamyarContractStatuses(state, data) {
    state.hamyarContractStatuses = data;
  },
  setChances(state, data) {
    state.chances = data;
  },

  setCalls(state, data) {
    state.calls = data;
  },

  setMessages(state, data) {
    state.messages = data;
  },

  setContracts(state, data) {
    state.contracts = data;
  },

  setMeetings(state, data) {
    state.meetings = data;
  },

  setTasks(state, data) {
    state.tasks = data;
  },
  setMessageStatuses(state, data) {
    state.messageStatuses = data;
  },

  setMessageTypes(state, data) {
    state.messageTypes = data;
  },

  setMessageActions(state, data) {
    state.messageActions = data;
  },

  setCallTypes(state, data) {
    state.callTypes = data;
  },

  setCallStatuses(state, data) {
    state.callStatuses = data;
  },

  setCallNatures(state, data) {
    state.callNatures = data;
  },

  setCallCategories(state, data) {
    state.callCategories = data;
  },

  setCallSubjects(state, data) {
    state.callSubjects = data;
  },

  setLeadAddressTypes(state, data) {
    state.leadAddressTypes = data;
  },

  setMeetingStatuses(state, data) {
    state.meetingStatuses = data;
  },

  setCheckListTypes(state, data) {
    state.checkListTypes = data;
  },

  setTaxRateTypes(state, data) {
    state.taxRateTypes = data;
  },

  setAddOrMinusTypes(state, data) {
    state.addOrMinusTypes = data;
  },

  setVoucherSearchTypes(state, data) {
    state.voucherSearchTypes = data;
  },

  setReceiveOptions(state, data) {
    state.receiveOptions = data;
  },

  setPaymentOptions(state, data) {
    state.paymentOptions = data;
  },

  setStudyFieldTypes(state, data) {
    state.studyFieldTypes = data;
  },

  setDegreeTypes(state, data) {
    state.degreeTypes = data;
  },

  setEmploymentType(state, data) {
    state.employmentTypes = data;
  },

  setInsuranceTypes(state, data) {
    state.insuranceTypes = data;
  },

  setServiceStatuses(state, data) {
    state.serviceStatuses = data;
  },

  setNationalityTypes(state, data) {
    state.nationalityTypes = data;
  },

  setOccupationCategories(state, data) {
    state.occupationCategories = data;
  },

  setTaxVehicles(state, data) {
    state.taxVehicles = data;
  },

  setTaxHousings(state, data) {
    state.taxHousings = data;
  },

  setEmploymentTypes(state, data) {
    state.employmentTypes = data;
  },

  setDecreaseSaleAddMinuses(state, data) {
    state.decreaseSaleAddMinuses = data;
  },

  setGiftTypes(state, data) {
    state.giftTypes = data;
  },

  setCalculateTypes(state, data) {
    state.calculateTypes = data;
  },
  setDepartments(state, data) {
    state.departments = data;
  },
  setContractTypes(state, data) {
    state.contractTypes = data;
  },
  setLeaveTypes(state, data) {
    state.leaveTypes = data;
  },
  setJobGroups(state, data) {
    state.jobGroups = data;
  },
  setInsuranceWorkplaces(state, data) {
    state.insuranceWorkplaces = data;
  },
  setAgreementRows(state, data) {
    state.agreementRows = data;
  },
  setCalculateDeductionRateTypes(state, data) {
    state.calculateDeductionRateTypes = data;
  },
  setFormulas(state, data) {
    state.formulas = data;
  },
  setExemptionTypes(state, data) {
    state.exemptionTypes = data;
  },
  setCalculateTaxForHourlys(state, data) {
    state.calculateTaxForHourlys = data;
  },
  setCalculateTaxTypes(state, data) {
    state.calculateTaxTypes = data;
  },
  setLegalTaxExceptions(state, data) {
    state.legalTaxExceptions = data;
  },
  setFunctionTypes(state, data) {
    state.functionTypes = data;
  },
  setCalculateOffOverTimeTypes(state, data) {
    state.calculateOffOverTimeTypes = data;
  },
  setBenefitsAndDeductions(state, data) {
    state.benefitsAndDeductions = data;
  },
  setPersonnels(state, data) {
    state.personnels = data;
  },
  setAdditionalContractParameters(state, data) {
    state.additionalContractParameters = data;
  },

  setShamsiMonths(state, data) {
    state.shamsiMonths = data;
  },

  setSuites(state, data) {
    state.suites = data;
  },

  setParticipation(state, data) {
    state.participation = data;
  },

  setCrimesRewardSubject(state, data) {
    state.crimesRewardSubject = data;
  },

  setPaymentNotificationType(state, data) {
    state.paymentNotificationType = data;
  },

  setEstimationSubject(state, data) {
    state.estimationSubject = data;
  },

  setCrimesRewardType(state, data) {
    state.crimesRewardType = data;
  },

  setUnitCount(state, data) {
    state.unitCount = data;
  },

  setAdvanceCartableConfirm(state, data) {
    state.advanceCartableConfirm = data;
  },

  setLeaveCartableConfirm(state, data) {
    state.leaveCartableConfirm = data;
  },

  setHamsazSmsTemplates(state, data) {
    state.hamsazSmsTemplates = data;
  },

  setHamsazSmsSettings(state, data) {
    state.hamsazSmsSettings = data;
  },

  setFinancialSystemTypes(state, data) {
    state.financialSystemTypes = data;
  },

  setExcelSamples(state, data) {
    state.excelSamples = data;
  },

  setEmployeeClubPermissions(state, data) {
    state.employeeClubPermissions = data;
  },

  setSaltDateTypes(state, data) {
    state.saltDateTypes = data;
  },

  setSaleTeams(state, data) {
    state.saleTeams = data;
  },

  setSaleRegions(state, data) {
    state.saleRegions = data;
  },

  setTaxBillTypes(state, data) {
    state.taxBillTypes = data;
  },

  setTaxBillPatterns(state, data) {
    state.taxBillPatterns = {
      ...state.taxBillPatterns,
      [data.billTypeId]: data.items,
    };
  },

  setTaxBillSubjects(state, data) {
    state.taxBillSubjects = data;
  },

  setTaxBuyerTypes(state, data) {
    state.taxBuyerTypes = data;
  },

  setTaxClearingMethods(state, data) {
    state.taxClearingMethods = data;
  },

  setTaxInvoiceStatuses(state, data) {
    state.taxInvoiceStatuses = data;
  },

  setTaxCurrencyTypes(state, data) {
    state.taxCurrencyTypes = data;
  },

  setTaxOrganizationTypes(state, data) {
    state.taxOrganizationTypes = data;
  },

  setTaxMltTypes(state, data) {
    state.taxMltTypes = data;
  },

  setOrderCartableConfirm(state, data) {
    state.orderCartableConfirm = data;
  },

  setTaskDateTypes(state, data) {
    state.taskDateTypes = data;
  },

  setTaskDeleteScopes(state, data) {
    state.taskDeleteScopes = data;
  },
};
